import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentMethodComponent } from '../common-liability/payment-method/payment-method.component';
import { DataTablesModule } from 'angular-datatables';
import { GridModule } from '@tmhcc-ng-lib/framwork/grid';

@NgModule({
  declarations: [PaymentMethodComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    DataTablesModule.forRoot()
  ],
  exports: [PaymentMethodComponent]
})
export class SharedPaymentMethodModule {}
